<div class="lum-modal order-transfer-line-items">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >Line Items (Order #{{ data.orderTransfer?.orderNumber }})</span
    >
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div class="table-wrapper">
      <table class="lum-table lum-table--classic striped">
        <tbody>
          <ng-container *ngFor="let item of orderItems">
            <tr>
              <td>[{{ item.internalSku }}] {{ item.productName }}</td>
              <td class="w-20 text-center">
                <i>x {{ item.orderedQty }}</i>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
